<div class="chatbox" id="chatBox">
    <div class="chatbox-close" (click)="chatboxClose()"></div>
    <div class="custom-tab-1">

        <ul class="nav nav-tabs review-tab" ngbNav #nav="ngbNav" [(activeId)]="active">
            <li [ngbNavItem]="1" class="nav-item">
                <a href="javascript:void(0);" ngbNavLink class="nav-link"> Notes </a>
                <ng-template ngbNavContent>
                    <div class="card mb-sm-3 mb-md-0 note_card">
                        <div class="card-header chat-list-header text-center">
                            <a href="javascript:void(0)"><svg xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink" width="18px" height="18px"
                                    viewBox="0 0 24 24" version="1.1">
                                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <rect fill="#000000" x="4" y="11" width="16" height="2" rx="1" />
                                        <rect fill="#000000" opacity="0.3"
                                            transform="translate(12.000000, 12.000000) rotate(-270.000000) translate(-12.000000, -12.000000) "
                                            x="4" y="11" width="16" height="2" rx="1" />
                                    </g>
                                </svg></a>
                            <div>
                                <h6 class="mb-1">Notes</h6>
                                <p class="mb-0">Add New Nots</p>
                            </div>
                            <a href="javascript:void(0)"><svg xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink" width="18px" height="18px"
                                    viewBox="0 0 24 24" version="1.1">
                                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <rect x="0" y="0" width="24" height="24" />
                                        <path
                                            d="M14.2928932,16.7071068 C13.9023689,16.3165825 13.9023689,15.6834175 14.2928932,15.2928932 C14.6834175,14.9023689 15.3165825,14.9023689 15.7071068,15.2928932 L19.7071068,19.2928932 C20.0976311,19.6834175 20.0976311,20.3165825 19.7071068,20.7071068 C19.3165825,21.0976311 18.6834175,21.0976311 18.2928932,20.7071068 L14.2928932,16.7071068 Z"
                                            fill="#000000" fill-rule="nonzero" opacity="0.3" />
                                        <path
                                            d="M11,16 C13.7614237,16 16,13.7614237 16,11 C16,8.23857625 13.7614237,6 11,6 C8.23857625,6 6,8.23857625 6,11 C6,13.7614237 8.23857625,16 11,16 Z M11,18 C7.13400675,18 4,14.8659932 4,11 C4,7.13400675 7.13400675,4 11,4 C14.8659932,4 18,7.13400675 18,11 C18,14.8659932 14.8659932,18 11,18 Z"
                                            fill="#000000" fill-rule="nonzero" />
                                    </g>
                                </svg></a>
                        </div>
                        <div class="card-body contacts_body p-0 dz-scroll" id="DZ_W_Contacts_Body2">
                            <ul class="contacts">
                                @for(note of notes; track note){
                                <li class="active">
                                    <div class="d-flex bd-highlight">
                                        <div class="user_info">
                                            <span>{{ note.title }}</span>
                                            <p>{{ note.date }}</p>
                                        </div>
                                        <div class="ms-auto">
                                            <a href="javascript:void(0)" class="btn btn-primary btn-xs sharp me-2"><i
                                                    class="fas fa-pencil-alt"></i></a>
                                            <a href="javascript:void(0)" class="btn btn-danger btn-xs sharp"><i
                                                    class="fas fa-trash-alt"></i></a>
                                        </div>
                                    </div>
                                </li>
                                }
                            </ul>
                        </div>
                    </div>
                </ng-template>
            </li>
            <li [ngbNavItem]="2" class="nav-item">
                <a href="javascript:void(0);" ngbNavLink class="nav-link"> Alerts </a>
                <ng-template ngbNavContent>
                    <div class="card mb-sm-3 mb-md-0 contacts_card">
                        <div class="card-header chat-list-header text-center">
                            <a href="javascript:void(0);"><svg xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink" width="18px" height="18px"
                                    viewBox="0 0 24 24" version="1.1">
                                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <rect x="0" y="0" width="24" height="24" />
                                        <circle fill="#000000" cx="5" cy="12" r="2" />
                                        <circle fill="#000000" cx="12" cy="12" r="2" />
                                        <circle fill="#000000" cx="19" cy="12" r="2" />
                                    </g>
                                </svg></a>
                            <div>
                                <h6 class="mb-1">Notications</h6>
                                <p class="mb-0">Show All</p>
                            </div>
                            <a href="javascript:void(0);"><svg xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink" width="18px" height="18px"
                                    viewBox="0 0 24 24" version="1.1">
                                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <rect x="0" y="0" width="24" height="24" />
                                        <path
                                            d="M14.2928932,16.7071068 C13.9023689,16.3165825 13.9023689,15.6834175 14.2928932,15.2928932 C14.6834175,14.9023689 15.3165825,14.9023689 15.7071068,15.2928932 L19.7071068,19.2928932 C20.0976311,19.6834175 20.0976311,20.3165825 19.7071068,20.7071068 C19.3165825,21.0976311 18.6834175,21.0976311 18.2928932,20.7071068 L14.2928932,16.7071068 Z"
                                            fill="#000000" fill-rule="nonzero" opacity="0.3" />
                                        <path
                                            d="M11,16 C13.7614237,16 16,13.7614237 16,11 C16,8.23857625 13.7614237,6 11,6 C8.23857625,6 6,8.23857625 6,11 C6,13.7614237 8.23857625,16 11,16 Z M11,18 C7.13400675,18 4,14.8659932 4,11 C4,7.13400675 7.13400675,4 11,4 C14.8659932,4 18,7.13400675 18,11 C18,14.8659932 14.8659932,18 11,18 Z"
                                            fill="#000000" fill-rule="nonzero" />
                                    </g>
                                </svg></a>
                        </div>
                        <div class="card-body contacts_body p-0 dz-scroll" id="DZ_W_Contacts_Body1">
                            <ul class="contacts">
                                <li class="name-first-letter">SEVER STATUS</li>
                                <li class="active">
                                    <div class="d-flex bd-highlight">
                                        <div class="img_cont primary">KK</div>
                                        <div class="user_info">
                                            <span>David Nester Birthday</span>
                                            <p class="text-primary">Today</p>
                                        </div>
                                    </div>
                                </li>
                                <li class="name-first-letter">SOCIAL</li>
                                <li>
                                    <div class="d-flex bd-highlight">
                                        <div class="img_cont success">RU</div>
                                        <div class="user_info">
                                            <span>Perfection Simplified</span>
                                            <p>Jame Smith commented on your status</p>
                                        </div>
                                    </div>
                                </li>
                                <li class="name-first-letter">SEVER STATUS</li>
                                <li>
                                    <div class="d-flex bd-highlight">
                                        <div class="img_cont primary">AU</div>
                                        <div class="user_info">
                                            <span>AharlieKane</span>
                                            <p>Sami is online</p>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="d-flex bd-highlight">
                                        <div class="img_cont info">MO</div>
                                        <div class="user_info">
                                            <span>Athan Jacoby</span>
                                            <p>Nargis left 30 mins ago</p>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="card-footer"></div>
                    </div>
                </ng-template>
            </li>
            <li [ngbNavItem]="3" class="nav-item">
                <a href="javascript:void(0);" ngbNavLink class="nav-link"> Chat </a>
                <ng-template ngbNavContent>
                    <div class="card mb-sm-3 mb-md-0 contacts_card dz-chat-user-box" [class.d-none]="isVisited == true">
                        <div class="card-header chat-list-header text-center">
                            <a href="javascript:void(0)"><svg xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink" width="18px" height="18px"
                                    viewBox="0 0 24 24" version="1.1">
                                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <rect fill="#000000" x="4" y="11" width="16" height="2" rx="1" />
                                        <rect fill="#000000" opacity="0.3"
                                            transform="translate(12.000000, 12.000000) rotate(-270.000000) translate(-12.000000, -12.000000) "
                                            x="4" y="11" width="16" height="2" rx="1" />
                                    </g>
                                </svg></a>
                            <div>
                                <h6 class="mb-1">Chat List</h6>
                                <p class="mb-0">Show All</p>
                            </div>
                            <a href="javascript:void(0)"><svg xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink" width="18px" height="18px"
                                    viewBox="0 0 24 24" version="1.1">
                                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <rect x="0" y="0" width="24" height="24" />
                                        <circle fill="#000000" cx="5" cy="12" r="2" />
                                        <circle fill="#000000" cx="12" cy="12" r="2" />
                                        <circle fill="#000000" cx="19" cy="12" r="2" />
                                    </g>
                                </svg></a>
                        </div>
                        <div class="card-body contacts_body p-0 dz-scroll  " id="DZ_W_Contacts_Body">
                            <ul class="contacts">
                                <li class="name-first-letter">A</li>
                                @for(chat of chatsA; track chat){
                                <li class="active dz-chat-user" (click)="activeMenu()">
                                    <div class="d-flex bd-highlight">
                                        <div class="img_cont">
                                            <img src="{{ chat.img }}" class="rounded-circle user_img" alt="">
                                            <span class="{{ chat.status }}"></span>
                                        </div>
                                        <div class="user_info">
                                            <span>{{ chat.name }}</span>
                                            <p>{{ chat.desc }}</p>
                                        </div>
                                    </div>
                                </li>
                                }
                                <li class="name-first-letter">B</li>
                                @for(chat of chatsB; track chat){
                                <li class="active dz-chat-user" (click)="activeMenu()">
                                    <div class="d-flex bd-highlight">
                                        <div class="img_cont">
                                            <img src="{{ chat.img }}" class="rounded-circle user_img" alt="">
                                            <span class="{{ chat.status }}"></span>
                                        </div>
                                        <div class="user_info">
                                            <span>{{ chat.name }}</span>
                                            <p>{{ chat.desc }}</p>
                                        </div>
                                    </div>
                                </li>
                                }
                                <li class="name-first-letter">D</li>
                                @for(chat of chatsD; track chat){
                                <li class="active dz-chat-user" (click)="activeMenu()">
                                    <div class="d-flex bd-highlight">
                                        <div class="img_cont">
                                            <img src="{{ chat.img }}" class="rounded-circle user_img" alt="">
                                            <span class="{{ chat.status }}"></span>
                                        </div>
                                        <div class="user_info">
                                            <span>{{ chat.name }}</span>
                                            <p>{{ chat.desc }}</p>
                                        </div>
                                    </div>
                                </li>
                                }
                                <li class="name-first-letter">J</li>
                                @for(chat of chatsJ; track chat){
                                <li class="active dz-chat-user" (click)="activeMenu()">
                                    <div class="d-flex bd-highlight">
                                        <div class="img_cont">
                                            <img src="{{ chat.img }}" class="rounded-circle user_img" alt="">
                                            <span class="{{ chat.status }}"></span>
                                        </div>
                                        <div class="user_info">
                                            <span>{{ chat.name }}</span>
                                            <p>{{ chat.desc }}</p>
                                        </div>
                                    </div>
                                </li>
                                }
                                <li class="name-first-letter">O</li>
                                @for(chat of chatsO; track chat){
                                <li class="active dz-chat-user" (click)="activeMenu()">
                                    <div class="d-flex bd-highlight">
                                        <div class="img_cont">
                                            <img src="{{ chat.img }}" class="rounded-circle user_img" alt="">
                                            <span class="{{ chat.status }}"></span>
                                        </div>
                                        <div class="user_info">
                                            <span>{{ chat.name }}</span>
                                            <p>{{ chat.desc }}</p>
                                        </div>
                                    </div>
                                </li>
                                }
                            </ul>
                        </div>
                    </div>
                    <div class="card chat dz-chat-history-box" [class.d-none]="isVisited == false">
                        <div class="card-header chat-list-header text-center">
                            <a href="javascript:void(0)" class="dz-chat-history-back" (click)="activeMenu()">
                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                    width="18px" height="18px" viewBox="0 0 24 24" version="1.1">
                                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <polygon points="0 0 24 0 24 24 0 24" />
                                        <rect fill="#000000" opacity="0.3"
                                            transform="translate(15.000000, 12.000000) scale(-1, 1) rotate(-90.000000) translate(-15.000000, -12.000000) "
                                            x="14" y="7" width="2" height="10" rx="1" />
                                        <path
                                            d="M3.7071045,15.7071045 C3.3165802,16.0976288 2.68341522,16.0976288 2.29289093,15.7071045 C1.90236664,15.3165802 1.90236664,14.6834152 2.29289093,14.2928909 L8.29289093,8.29289093 C8.67146987,7.914312 9.28105631,7.90106637 9.67572234,8.26284357 L15.6757223,13.7628436 C16.0828413,14.136036 16.1103443,14.7686034 15.7371519,15.1757223 C15.3639594,15.5828413 14.7313921,15.6103443 14.3242731,15.2371519 L9.03007346,10.3841355 L3.7071045,15.7071045 Z"
                                            fill="#000000" fill-rule="nonzero"
                                            transform="translate(9.000001, 11.999997) scale(-1, -1) rotate(90.000000) translate(-9.000001, -11.999997) " />
                                    </g>
                                </svg>
                            </a>
                            <div>
                                <h6 class="mb-1">Chat with Khelesh</h6>
                                <p class="mb-0 text-success">Online</p>
                            </div>
                            <div class="dropdown">
                                <a href="#" data-bs-toggle="dropdown" aria-expanded="false"><svg
                                        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                        width="18px" height="18px" viewBox="0 0 24 24" version="1.1">
                                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                            <rect x="0" y="0" width="24" height="24" />
                                            <circle fill="#000000" cx="5" cy="12" r="2" />
                                            <circle fill="#000000" cx="12" cy="12" r="2" />
                                            <circle fill="#000000" cx="19" cy="12" r="2" />
                                        </g>
                                    </svg></a>
                                <ul class="dropdown-menu dropdown-menu-end">
                                    <li class="dropdown-item"><i class="fa fa-user-circle text-primary me-2"></i> View
                                        profile</li>
                                    <li class="dropdown-item"><i class="fa fa-users text-primary me-2"></i> Add to close
                                        friends</li>
                                    <li class="dropdown-item"><i class="fa fa-plus text-primary me-2"></i> Add to group
                                    </li>
                                    <li class="dropdown-item"><i class="fa fa-ban text-primary me-2"></i> Block</li>
                                </ul>
                            </div>
                        </div>
                        <div class="card-body msg_card_body dz-scroll contacts_body" id="DZ_W_Contacts_Body3">

                            @for (row of chetList; track row) {
                            @if(row.send){
                            <div class="d-flex justify-content-start mb-4">
                                <div class="img_cont_msg">
                                    <img src="{{ row.img }}" class="rounded-circle user_img_msg" alt="">
                                </div>
                                <div class="msg_cotainer">
                                    {{ row.msg }}
                                    <span class="msg_time">{{ row.msgTime }}</span>
                                </div>
                            </div>
                            } @else {
                            <div class="d-flex justify-content-end mb-4">
                                <div class="msg_cotainer_send">
                                    {{ row.msg }}
                                    <span class="msg_time_send">{{ row.msgTime }}</span>
                                </div>
                                <div class="img_cont_msg">
                                    <img src="{{ row.img }}" class="rounded-circle user_img_msg" alt="">
                                </div>
                            </div>
                            }
                            }

                        </div>
                        <div class="card-footer type_msg">
                            <div class="input-group">
                                <textarea class="form-control" placeholder="Type your message..."></textarea>
                                <div class="input-group-append">
                                    <button type="button" class="btn btn-primary"><i
                                            class="fa fa-location-arrow"></i></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </li>
        </ul>
        <div [ngbNavOutlet]="nav"></div>
    </div>
</div>